import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Icon } from 'loyal-react'

import '@loyal_template/autocomplete.css'

import PropTypes from 'prop-types'
import ReactImageFallback from 'react-image-fallback'
import imagefallback from '@loyal_images/products/product_placeholder.png'

class AutoCompleteProducts extends Component {
  render () {
    return (
      <div
        className={`box-autocomplete-products box-autocomplete col-12 px-1 border border-color-ui-4 bg-white radius-bottom ${this.props.show ? '' : 'd-none'}`}
      >
        <div
          className={`row ${
            this.props.verifyTrigger ? 'd-block' : 'd-none'
          }`}
        >
          <div className='col-12'>
            <p id='mostSearchedCategories-title' className='hide-absolute'>Termo buscado nas categorias</p>
            <ul
              className={`${
                this.props.verifyTrigger ? 'd-block' : 'd-none'
              }`}
              aria-labelledby='mostSearchedCategories-title'
            >
              {this.props.categories &&
                      this.props.autoCompleteFilled &&
                      this.props.categories.map((element, index) => {
                        return (
                          <li>
                            <div className='row px-1 align-items-center h-100 py-1 bg-ui-4-hv'>
                              <div className='col-auto'>
                                <Icon
                                  iconName='icon_search'
                                  className='d-inline icon-sm color-ui-3'
                                />
                              </div>
                              <div className='col-6 mr-auto color-ui-2 txt-body-sm'>
                                <Link
                                  key={index}
                                  to={`/search?term=${this.props.term}&category=${element.id}`}
                                  onChange={() => this.props.setTerm('')}
                                  onBlur={() => this.props.emptySearch()}
                                  className='box-autocomplete-item'
                                >
                                  <span className='hide-absolute'>{this.props.term} na categoria {element.name}{ ((this.props.products && this.props.products.length === 0) && (this.props.services && this.props.services.length === 0) && this.props.categories.length - 1 === index) && ' (Último item, continue para fechar)'}</span>
                                  <span aria-hidden='true'>
                                    {this.props.term}
                                  </span>
                                  <span className='color-ui-3 txt-body-sm' aria-hidden='true'>
                                    <strong>{' '}{element.name}</strong>
                                  </span>
                                </Link>
                              </div>
                              <div className='col txt-right'>
                                <span className='hide-absolute'>
                                  {element.count === 1
                                    ? 'Encontrado '
                                    : 'Encontrados '}
                                  {element.count}{' '}
                                  {element.count === 1
                                    ? 'resultado'
                                    : 'resultados'}
                                </span>
                                <strong className='txt-body-sm' aria-hidden='true'>
                                  {element.count}{' '}
                                </strong>
                                <span className='txt-body-sm' aria-hidden='true'>
                                  {element.count === 1
                                    ? 'resultado'
                                    : 'resultados'}
                                </span>
                              </div>
                            </div>
                          </li>
                        )
                      })}
            </ul>
          </div>
          <div className='col-12 px-0 border-top border-color-ui-4 bg-white radius-bottom  '>
            <p id='mostSearchedProducts-title' className='hide-absolute'>Sugestão de produtos</p>
            <ul aria-labelledby='mostSearchedProducts-title'>
              {this.props.services &&
                    this.props.autoCompleteFilled &&
                    this.props.services.map((element, index) => {
                      return (
                        <li>
                          <div
                            key={index}
                            className='cart-item row mx-0 bg-ui-4-hv px-2 border-bottom border-color-ui-4'
                          >
                            <div className='col-12 '>
                              <div className='row align-items-center h-100'>
                                <div className='cart-img px-0 py-2 col-auto txt-center'>
                                  <ReactImageFallback
                                    src={element.image}
                                    fallbackImage={imagefallback}
                                    initialImage={imagefallback}
                                    alt={``}
                                    className='card-image-fallback search-img'
                                    aria-hidden='true'
                                  />
                                </div>
                                <div className='cart-product-info col'>
                                  <div className='cart-product-info row'>
                                    <div className='product-infos col-12 mx-0'>
                                      <Link
                                        to={element.path}
                                        onClick={() => {
                                          this.props.emptySearch()
                                        }}
                                        onBlur={() => this.props.emptySearch()}
                                        className='box-autocomplete-item txt-subtitle txt-font-body color-ui-2'
                                        role='link'
                                      >
                                        <span aria-hidden='true'>{`${element.name.substring(0, 70)} `}</span>
                                        <span className='hide-absolute'>{`${element.name} `} { ((this.props.products && this.props.products.length === 0) && this.props.services.length - 1 === index) && '(Último item, continue para fechar)'}</span>
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      )
                    })}
              {this.props.products &&
                    this.props.autoCompleteFilled &&
                    this.props.products.map((element, index) => {
                      return (
                        <li>
                          <div
                            key={index}
                            className='cart-item row mx-0 bg-ui-4-hv px-2 border-bottom border-color-ui-4'
                          >
                            <div className='col-12 '>
                              <div className='row align-items-center h-100'>
                                <div className='cart-img px-0 py-2 col-auto txt-center'>
                                  <ReactImageFallback
                                    src={element.imageUrl}
                                    fallbackImage={imagefallback}
                                    initialImage={imagefallback}
                                    alt={`Imagem do produto ${element.name}`}
                                    className='card-image-fallback search-img'
                                  />
                                </div>
                                <div className='cart-product-info col'>
                                  <div className='cart-product-info row'>
                                    <div className='product-infos col-12 mx-0'>
                                      <Link
                                        to={`/products/${element.sku}`}
                                        onClick={() => {
                                          this.props.emptySearch()
                                        }}
                                        onBlur={() => this.props.emptySearch()}
                                        className='box-autocomplete-item txt-subtitle txt-font-body color-ui-2'
                                      >
                                        <span aria-hidden='true'>{`${element.name.substring(0, 70)} `}</span>
                                        <span className='hide-absolute'>{`${element.name} `}</span>
                                        { (this.props.products.length - 1 === index) && <span className='hide-absolute'>(Último item, continue para fechar)</span>}
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      )
                    })}
            </ul>
          </div>
        </div>
      </div>
    )
  }
}

AutoCompleteProducts.propTypes = {
  emptySearch: PropTypes.func,
  setTerm: PropTypes.func,
  term: PropTypes.string,
  categories: PropTypes.array,
  services: PropTypes.array,
  products: PropTypes.array,
  autoCompleteFilled: PropTypes.bool,
  verifyTrigger: PropTypes.bool,
  show: PropTypes.bool
}

export default AutoCompleteProducts



// WEBPACK FOOTER //
// ./src/App/Header/Search/AutoCompleteProducts.js